import React, {useState, useEffect} from "react";
import {useSearchParams, useLocation} from "react-router-dom";
import ContentLayout from "../../layout/ContentLayout";
import AnnoucementTable from "../../components/tables/AnnoucementTable";
import {Tabs} from "antd";
import AddAnnoucement from "../../components/annoucement/AddAnnoucement";

export default function Annoucement () {
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'annoucement');

    useEffect(() => {
        const tabFromUrl = searchParams.get('tab');
        if (tabFromUrl && tabFromUrl !== activeTab) {
            setActiveTab(tabFromUrl);
        }
    }, [searchParams]);

    useEffect(() => {
        if (location.state?.formData) {
            setActiveTab('newAnnoucement');
            setSearchParams({ tab: 'newAnnoucement' });
        }
    }, [location.state]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        setSearchParams({ tab: key });
    };

    const tabItems = [
        {
            key: 'annoucement',
            label: 'Lista objava',
            children: <AnnoucementTable />,
        },
        {
            key: 'newAnnoucement',
            label: 'Nova objava',
            children: <AddAnnoucement />,
        },
    ];

    return(
        <ContentLayout>
            <Tabs
                activeKey={activeTab}
                onChange={handleTabChange}
                items={tabItems}
                className="medics_tab"
            />
        </ContentLayout>
    )
}